module.exports = {
	"articleTitle1": "State Street Starbucks reopens its doors",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Starbucks",
	"articleLink1": "https://www.michigandaily.com/news/starbucks-re-opens-major-renovations",
	"articleLink2": "https://www.michigandaily.com/article/abortion-clinic-ann-arbor-lead",
	"articleSnippet1": "Jan 23, 2014 ... The Starbucks located on the corner of South State and East Liberty ... “Some \nmemorabilia and a map of Ann Arbor are some of the major ...",
	"articleSnippet2": "Apr 1, 2014 ... ... in the basement of the building shared by the Starbucks on East Liberty. .... “\nThere's no question about it — birth control played a major role in the ... and \ncarried out near the St. Louis metropolitan area, 9,000 women, ages ...",
	"foodRecommendations": [],
	"articleTitle2": "'A well-kept secret' : How pregnancy counseling centers influence ...",
	"address": "300 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279469,
		"lng": -83.748892
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/starbucksmain.json
// module id = 978
// module chunks = 0